import { component as defineComponent } from 'flightjs';
import withChildComponents from 'flight-with-child-components';
import DetachedDropdownFilterUI from 'browse/ui/detached-dropdown-filter';
import ListingSummaryUI from 'browse/ui/listings-summary';
import ConditionalOptionsFilterUI from 'browse/ui/conditional-options-filter';
import StyledSelectFilterUI from 'browse/ui/styled-select-filter';

export default defineComponent(function () {
    this.attributes({
        listingSummary: '[data-listings-summary]',
        detachedDropdownFilter: '[data-detached-dropdown-filter]',
        styledSelectFilter: '[data-styled-select-filter]',
        conditionalFilter: '[data-conditional-options-filter]',
    });

    this.after('initialize', function () {
        this.initChildComponents();
    });

    this.initChildComponents = function () {
        this.attachChild(ListingSummaryUI, this.select('listingSummary'));
        this.attachChild(DetachedDropdownFilterUI, this.select('detachedDropdownFilter'));
        this.attachChild(ConditionalOptionsFilterUI, this.select('conditionalFilter'));
        this.attachChild(StyledSelectFilterUI, this.select('styledSelectFilter'));
    };
}, withChildComponents);



// WEBPACK FOOTER //
// ./src/web/js/browse/ui/listings-toolbar.js